import Hero from "@/components/sections/Hero";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import About from "@/components/sections/About";
import WhyChoose from "@/components/sections/WhyChoose";
import Products from "@/components/sections/Products";
import FarmersPrefer from "@/components/sections/FarmersPrefer";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <About />
      <WhyChoose />
      <Products />
      <FarmersPrefer />
      <Gallery />
      <Testimonials />
      <FAQ />
      <Contact />
    </main>
  );
}
